module.exports = __webpack_public_path__ + "static/media/pfsense.d58cdbe0.jpg";